<bn-loading-overlay></bn-loading-overlay>

<h5>Documentos enviados</h5>
<div class="container">
  <form class="mt-3 mx-auto" [formGroup]="pesquisaForm" *ngIf="pesquisaForm" (keyup.enter)="buscar()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/acompanhamento-documento-depr/cadastro']"
          placement="bottom" [disabled]="!podeEnviar"><i class="fa fa-file-signature">
          </i> Enviar documento de acompanhamento </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" autofocus (click)="buscar()"
          [disabled]="!pesquisaForm.valid">Pesquisar</button>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-3">
        <label class="form-label">Agente Financeiro:</label>
        <ng-select
          id="cnpjAgenteFinanceiro"
          [items]="agentesFinanceiros"
          bindLabel="nome"
          [multiple]="false"
          [clearable]="true"
          [readonly]="!podeEscolherAgente()"
          [clearOnBackspace]="true"
          formControlName="cnpjAgenteFinanceiro"
          [searchable]="true"
          bindValue="cnpj"
          placeholder="Todos"
          class="auto-grow">
          <ng-template ng-label-tmp let-item="item">
            {{ item.nome }}
          </ng-template>
        </ng-select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="statusArquivo">Status do arquivo: </label>
        <select id="statusArquivo" class="form-select" formControlName="statusArquivo">
          <option [selected]="true" [ngValue]=null>Todos</option>
          <option *ngFor="let status of valoresStatus" [ngValue]="status.valor">{{ status.descricao }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label" for="tipoDocumento">Tipo documento: </label>
        <select class="form-select" name="tipoDocumento" formControlName="tipoDocumento">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let tipo of tiposDosumento" [ngValue]="tipo.id">{{ tipo.descricao }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label class="form-label">Id. documento: </label>
        <input class="form-control" name="identificadorArquivo" formControlName="identificadorArquivo" placeholder="Ex: 1-2025">
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-3">
        <label class="form-label">Data de envio inicial:</label>
        <bn-datepicker idInput="dataEnvioInicial" name="dataEnvioInicial" formControlName="dataEnvioInicial">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="dataEnvioFinal">Data de envio final:</label>
        <bn-datepicker idInput="dataEnvioFinal" name="dataEnvioFinal" formControlName="dataEnvioFinal">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="competencia">Competência: </label>
        <select id="competencia" class="form-control" formControlName="competencia">
          <option [selected]="true" [ngValue]=null>Todos</option>
          <option *ngFor="let valor of competencias" [ngValue]="valor">{{ valor }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="periodo">Período de competência: </label>
        <select class="form-control" name="periodo" formControlName="periodo">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let periodo of periodos" [ngValue]="periodo.id">{{ periodo.descricao }}</option>
        </select>
      </div>
    </div>
  </form>
</div>

<app-acompanhamento-depr-listagem *ngIf="pesquisado"
  [agentesFinanceiros]="agentesFinanceiros"
  [acompanhamentos]="acompanhamentos"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [ehAgenteFinanceiro]="ehAgenteFinanceiro"
  (aoMudarPagina)="mudancaPagina($event)"
></app-acompanhamento-depr-listagem>
